import {
  useParams,
  useNavigate as useReactNavigate,
  useLocation,
} from "react-router-dom";

export const useNavigate = () => {
  const reactNavigate = useReactNavigate();
  const location = useLocation();
  const { tenant_code } = useParams();

  const navigate = (path: string | number, options?: { replace?: boolean }) => {
    const params = getUTmParams(window.location.search);
    const opt = {
      ...options,
      state: {
        ...location?.state,
        utm_source: params.utm_source
          ? params.utm_source
          : location?.state?.utm_source ?? "",
        utm_medium: params.utm_medium
          ? params.utm_medium
          : location?.state?.utm_medium ?? "",
        utm_campaign: params.utm_campaign
          ? params.utm_campaign
          : location?.state?.utm_campaign ?? "",
        utm_term: params.utm_term
          ? params.utm_term
          : location?.state?.utm_term ?? "",
        utm_content: params.utm_content
          ? params.utm_content
          : location?.state?.utm_content ?? "",
      },
    };

    if (typeof path === "number") {
      reactNavigate(path.toString(), opt);
    } else if (path.startsWith("?")) {
      reactNavigate(path, opt);
    } else {
      reactNavigate(
        `/${tenant_code}/${path.startsWith("/") ? path.substring(1) : path}`,
        opt,
      );
    }
  };

  return navigate;
};

const getUTmParams = (searchStr: string) => {
  return searchStr
    .substring(1)
    .split("&")
    .reduce(
      (acc, pair) => {
        const [key, value] = pair.split("=");
        if (key.startsWith("utm_")) {
          acc[key] = decodeURIComponent(value);
        }
        return acc;
      },
      {} as Record<string, string>,
    );
};
